const initialFields = {
  parentalEducation: 'High School and Above',
  motherEducation: 'High School and Above',
  housingCondition: 'Pakka',
  petsAtHome: 'No',
  waterSource: 'tap',
};

export default initialFields;
